import { render } from "./MediaCards.vue?vue&type=template&id=735d43e9&ts=true"
import script from "./MediaCards.vue?vue&type=script&lang=ts"
export * from "./MediaCards.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src329832614/src/web-ext-giantstep/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__